import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
// Add Calendar Settings
export const add_calendar_settings = async (values) => {
    let response = await axios.post(`${baseURL}/api/calendar-settings`, values);
    return response.data;
}
// List of Calendar Settings
export const get_all_calendar_settings = async () => {
    let response = await axios.get(baseURL + "/api/calendar-settings");
    return response.data;
  }
  // Get All Calendar Settings Logs
export const get_all_calendar_settings_logs = async () => {
    let response = await axios.get(`${baseURL}/api/calendarsettings-logs`);
    return response.data;
  };